document.addEventListener('DOMContentLoaded', () => {
  const specificationBlocks = document.querySelectorAll('.specifications-block');

  specificationBlocks.forEach((block) => {
    const list = block.querySelector('.specifications-block__list');

    const cloneElem = block.querySelector('.specifications-block__items');
    const initialHTML = cloneElem.outerHTML;

    // Counter for unique suffixes
    let suffixCounter = 0;

    const generateUniqueSuffix = () => `_${String(suffixCounter++).padStart(2, '0')}`;

    attachEvent('.specifications-block__add', 'click', () => {
      const clonedItems = document.createElement('div');
      clonedItems.innerHTML = initialHTML.trim();
      const newBlock = clonedItems.firstChild;

      const uniqueSuffix = generateUniqueSuffix();

      newBlock.querySelectorAll('input, label, select, textarea').forEach((element) => {
        if (element.id) {
          element.id = element.id.replace(/_\d{2}$/, '') + uniqueSuffix;
        }

        if (element.name) {
          element.name = element.name.replace(/_\d{2}$/, '') + uniqueSuffix;
          element.setAttribute('data-fv-name', element.name);
        }

        if (element.getAttribute('for')) {
          element.setAttribute('for', element.getAttribute('for').replace(/_\d{2}$/, '') + uniqueSuffix);
        }
      });

      block.querySelectorAll('.specifications-block__items').forEach((item) => {
        item.classList.remove('last-added');
      });

      newBlock.classList.add('last-added');

      list.appendChild(newBlock);
    });

    attachEvent('.specifications-block__remove', 'click', (ev) => {
      const item = ev.target.closest('.specifications-block__items');
      if (item) {
        item.remove();
      }
    });
  });
});
